import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useFormContext } from 'react-hook-form';
import Stack from '@mui/material/Stack';

import { VpButton, VpHoverInfo } from '../../components';
import { VpHookFormInput, VpHookFormSelect, VpHookFormSwitch } from '../../inputs';
import { useFetchAllCampaigns } from '../../../hooks';

import { StyledStack, StyledButtonStack, FullWidthStack, SubTitle, Title } from './styles';
import { getUser } from '../../../redux/modules/auth';
import { CompilationSvg } from '../../svgs';

const labelProps = {
  icon: 'HelpCircle',
  iconProps: { size: '15px' }
};

const CreateCompilationForm = withRouter(
  ({ location, onCancel = () => {}, loading = false, username = '' }) => {
    const {
      formState: { isValid }
    } = useFormContext();

    const { data } = useFetchAllCampaigns();
    const options = data?.map((m) => ({ id: m?.value, label: m?.label })) || [];

    const campaignId = new URLSearchParams(location.search).get('campaignId');

    const autoLabel = (
      <VpHoverInfo
        title="Auto Include Future Video Submissions"
        label={`If enabled, any new submissions made to the associated campaign will automatically be included in the compilation. Don't worry! You can change this later.`}
        {...labelProps}
      />
    );

    const migrateLabel = (
      <VpHoverInfo
        title="Include Existing Videos Submissions"
        label={`If checked, all of the associated campaign's existing videos will be automatically included in your new compilation.`}
        {...labelProps}
      />
    );

    return (
      <StyledStack>
        <FullWidthStack>
          <CompilationSvg width="150px" height="auto" />
          <Title variant="h3">Get Started</Title>
          <SubTitle variant="dialogBody2">
            {`Easily create a compilation of your VideoPeel campaign videos and share them with the people that matter. 
            Select your campaign to start populating your compilation. Your compilation page will inherit your campaign's look and feel.`}
          </SubTitle>
        </FullWidthStack>

        <Stack gap="25px">
          <VpHookFormInput
            name="title"
            label="Video Compilation Page Name"
            placeholder="Video Compilation Page Name"
            defaultValue={`${username ? `${username}'s` : 'My'} Compilation Page`}
            disableHelperText
            smallLabel
            required
          />
          <VpHookFormSelect
            name="campaignId"
            label="Associated Campaign"
            placeholder="Select a Campaign"
            options={options}
            disableHelperText
            smallLabel
            required
            {...(campaignId ? { defaultValue: `${campaignId}` } : {})}
          />
          <VpHookFormSwitch
            label={migrateLabel}
            name="migrateVideos"
            defaultValue={false}
            disableHelperText
          />
          <VpHookFormSwitch
            label={autoLabel}
            name="autoInclude"
            defaultValue={true}
            disableHelperText
          />
        </Stack>
        <StyledButtonStack>
          <VpButton
            variant="contained"
            color="neutral"
            loading={loading}
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </VpButton>
          <VpButton
            variant="contained"
            name="createCompilationButton"
            type="submit"
            loading={loading}
            disabled={!isValid || loading}
          >
            Create Compilation
          </VpButton>
        </StyledButtonStack>
      </StyledStack>
    );
  }
);

CreateCompilationForm.propTypes = {
  username: PropTypes.string,
  loading: PropTypes.bool,
  onCancel: PropTypes.func
};

const mapStateToProps = (state) => ({
  username: getUser(state)?.firstName ?? ''
});

export default connect(mapStateToProps)(CreateCompilationForm);



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/CreateCompilationDialog/CreateCompilationForm.jsx